<template>
  <div class="survey-cake-page" :class="{ 'pdf-mode': isPDF }">
    <img src="@/assets/survey-cake/logo.png" class="logo" />
    <div class="class-page">
      <div class="page-title">
        <img src="@/assets/survey-cake/star-icon.png" class="star-icon" />
        <h3 class="GenSenRounded">在這次 DFC 行動中，看見自己的超能力</h3>
      </div>
      <div class="class-contain">
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-language-title.png"
                class="class-icon"
              />
              <div class="class-title-text">語文智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("語文智能").total >= 22
                  ? "你很會用寫的或用說的，分享自己的想法和行動故事。你的表達清楚又能打動別人，讓大家想一起參與行動。"
                  : "你可能有自己習慣的記錄和分享方式，比較少用寫的或用說的來表達，不過沒關係，未來還有很多機會可以探索自己的語文超能力唷！"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-red.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("語文智能").total >= 22
                  ? "試著用文字記下你們的行動過程，像是做了什麼、遇到什麼挑戰，讓大家可以一起回顧一路上的精彩故事。"
                  : "試著觀察自己什麼時候想主動說話，或想動筆寫下來，當你多說一點、多寫一點，你就會發現你的語文超能力正在閃閃發光。"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-math-title.png"
                class="class-icon"
              />
              <div class="class-title-text">邏輯數學智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("邏輯數學智能").total >= 22
                  ? "你很會分析資料，像偵探一樣尋找線索，帶著大家思考問題發生的可能原因，並找到更多可能的解決方法。"
                  : "你比較習慣用自己的經驗或直覺來瞭解問題，不過，其實一個問題的產生有很多原因，只要多練習，你也能用更全面的角度看事情唷！"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-orange.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("邏輯數學智能").total >= 22
                  ? "下次小組討論時，試著帶大家思考和問題相關的人、事、時、地、物，發揮你的邏輯超能力，找看看要從哪個面向解決問題吧！"
                  : "下次小組討論時，試著多問「為什麼」，像是為什麼這件事會發生？保持好奇心，你會發現你正在發揮邏輯超能力。"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-nature-title.png"
                class="class-icon"
              />
              <div class="class-title-text">自然智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("自然智能").total >= 22
                  ? "你平常會注意身邊的自然環境和動植物，環保已經成為你的習慣。在討論時，你也會提出保護大自然的好方法，帶動大家一起愛護地球。"
                  : "這次你比較少注意大自然或環保議題，可能因為這些不是這次的主題。不過在日常生活中，還有很多機會可以發揮你的自然超能力唷！"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-green.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("自然智能").total >= 22
                  ? "期待你邀請大家一起隨手關燈、關水龍頭，或把垃圾分類好。這些小小的行動，都能讓動植物和人類過得更健康。"
                  : "在上學的路上，抬頭看看天空，或是觀察路邊的昆蟲、小動物，再把你的觀察分享給同學，說不定這些觀察會變成超棒的行動點子呢！"
              }}
            </div>
          </div>
        </div>
        <div class="class-card">
          <div class="class-top">
            <div class="class-title">
              <img
                src="@/assets/survey-cake/icon-eye-title.png"
                class="class-icon"
              />
              <div class="class-title-text">視覺空間智能</div>
            </div>
            <div class="class-text">
              {{
                getScoreByName("視覺空間智能").total >= 22
                  ? "你很會用畫畫、做簡報或拍影片的方式，把腦中的想法表達出來。因為有你，大家更容易了解你們的行動，也更有興趣一起參與呢！"
                  : "這次你比較少用畫畫、拍照或拍影片的方式記錄想法，你可能更習慣用其他方式表達，不過你的視覺超能力一直都在等你發揮唷！"
              }}
            </div>
          </div>
          <div class="class-bottom">
            <img src="@/assets/survey-cake/bulb-blue.png" class="bulb-icon" />
            <div class="info">
              {{
                getScoreByName("視覺空間智能").total >= 22
                  ? "下次試試新的呈現方式，例如換一種簡報或海報版型、在影片裡加入不同的轉場特效，讓你的視覺超能力繼續長大吧！"
                  : "下次試著把你的想法畫下來，或用手機、平板記錄行動的過程，說不定會激發新的靈感，讓你們的行動更有趣。"
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntelligenceFirstCard",
  props: {
    resultScore: {
      type: Array,
      required: true,
    },
    isPDF: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getScoreByName(name) {
      const scoreItem = this.resultScore.find((item) => item.name === name);
      return scoreItem || { total: 0 };
    },
  },
};
</script>

<style scoped lang="scss">
.survey-cake-page {
  width: 100vw;
  height: calc((3508 / 2480) * 100vw);
  background-color: #fae4cb;
  position: relative;
  padding: 5.8% 11.3% 7.2%;
  .logo {
    position: absolute;
    top: 2%;
    right: 3%;
    width: 4.5%;
  }
  .class-page {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .page-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 2%;
  }
  .star-icon {
    width: 4.4%;
    margin-right: 1.5%;
  }
  h3 {
    color: #eb6165;
    font-size: 2.7vw;
    font-weight: 700;
    line-height: 1.2;
  }
  .class-contain {
    display: flex;
    flex: 1 1 0%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .class-card {
    width: 100%;
    background-color: #fff;
    border-radius: 3.2vw;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .class-top {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    padding: 2% 8%;
  }
  .class-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      margin-bottom: 0.5rem;
    }
  }
  .class-icon {
    width: 2.5vw;
    margin-right: 0.5rem;
  }
  .class-title-text {
    font-size: 2vw;
    font-weight: 700;
    line-height: 1;
  }
  .class-card:nth-child(1) .class-title-text {
    color: #eb6165;
  }
  .class-card:nth-child(2) .class-title-text {
    color: #ea953a;
  }
  .class-card:nth-child(3) .class-title-text {
    color: #98ad44;
  }
  .class-card:nth-child(4) .class-title-text {
    color: #60abbc;
  }
  .class-text {
    color: #1e1e1e;
    font-size: 2vw;
    font-weight: 400;
    line-height: 2;
  }
  .class-bottom {
    position: relative;
    padding: 2% 8%;
  }
  .class-card:nth-of-type(1) .class-bottom {
    background-color: #faf1f1;
  }
  .class-card:nth-of-type(2) .class-bottom {
    background-color: #fdf4de;
  }
  .class-card:nth-of-type(3) .class-bottom {
    background-color: #fafbef;
  }
  .class-card:nth-of-type(4) .class-bottom {
    background-color: #eef7fa;
  }
  .bulb-icon {
    width: 1.7vw;
    position: absolute;
    top: 17%;
    left: 4%;
  }
  .info {
    color: #727171;
    font-size: 2vw;
    font-weight: 400;
    line-height: 2;
  }
}
.survey-cake-page.pdf-mode {
  width: 2480px;
  height: 3508px;
  h3 {
    font-size: 67px;
  }
  .class-card {
    border-radius: 80px;
  }
  .class-icon {
    width: 63px;
    margin-right: 1.5rem;
  }
  .class-title-text {
    font-size: 50px;
  }
  .class-text {
    font-size: 50px;
  }
  .bulb-icon {
    width: 40px;
    top: 20%;
  }
  .info {
    font-size: 50px;
  }
}
</style>
